/**
 * Point d'entree autonome du lecteur de la banniere.
 * Voir hero-film.scss pour la raison d'etre de ce fichier separe du bundle principal.
 */

import heroFilm from './components/hero-film';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => heroFilm.init());
} else {
  // Le script est differe par WP Rocket : le document est deja pret a ce stade.
  heroFilm.init();
}



// WEBPACK FOOTER //
// ./scripts/hero-film-entry.js